<template>
    <b-container>
        <b-row class="justify-content-md-center">
            <b-col cols="6">
                <el-card class="login-form-container">
                    <h3>Đặt mật khẩu mới</h3>
                    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                    <el-form ref="form" :model="form" :rules="rules" :hide-required-asterisk="true"
                             @keyup.enter.native="onSubmit">

                        <el-form-item label="Mật khẩu" prop="password">
                            <el-input v-model="form.password" type="password" placeholder="Mật khẩu"></el-input>
                        </el-form-item>
                        <el-form-item label="Nhập lại mật khẩu" prop="confirmPassword">
                            <el-input v-model="form.confirmPassword" type="password"
                                      placeholder="Nhập lại mật khẩu"></el-input>
                        </el-form-item>

                        <el-form-item class="el-col-24" style="text-align: center">

                            <el-button type="primary" size="medium" @click="onSubmit" :disabled="isRequesting"
                                       style="width:100%; height: 44px"
                            >Cập nhật
                            </el-button>
                        </el-form-item>

                    </el-form>
                </el-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {resetPassword} from "../services/authentication_service"

    export default {
        name: "ResetPassword",
        data() {
            let validateConfirmPassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Nhập lại mật khẩu'))
                } else if (value !== this.form.password) {
                    callback(new Error('Mật khẩu không khớp'))
                } else {
                    callback()
                }
            }
            return {
                form: {
                    name: '',
                    email: '',
                    password: '',
                    confirmPassword: ''
                },
                isRequesting: false,
                rules: {

                    password: [
                        {required: true, message: 'Hãy nhập mật khẩu ', trigger: 'change'},
                        {min: 8, message: 'Mật khẩu tối thiểu 8 kí tự', trigger: 'blur'}

                    ],
                    confirmPassword: [
                        {required: true, message: 'Hãy nhập lại mật khẩu ', trigger: 'change'},
                        {min: 8, message: 'Mật khẩu tối thiểu 8 kí tự', trigger: 'change'},
                        {validator: validateConfirmPassword, trigger: 'change'}
                    ]
                },
                errorMessage: null
            }
        },
        created() {
            if (this.isAuthenticated) {
                console.log("Authenticated")
                this.onSuccessLogin()
            }
        },
        methods: {
            onSubmit() {
                this.errorMessage = null
                let _this_ = this
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        _this_.isRequesting = true
                        resetPassword(this.$route.query.token, this.form.password, this.form.confirmPassword,
                            this.onSuccess,
                            this.onError,
                            () => _this_.isRequesting = false
                        )
                    } else {
                        return false
                    }
                })
            },
            onSuccess() {


                this.$message({
                    message: 'Khôi phục mật khẩu thành công, vui lòng đăng nhập lại',
                    type: 'success'
                })
                setTimeout(() => this.gotoLogin(), 1500)


            },
            onError(message) {
                this.errorMessage = message
                this.$message.error(message)
            },
            gotoLogin() {
                this.$router.push({name: 'login'})
            }

        }
    }
</script>

<style scoped>
    .login-form-container {
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 5px;
    }

    .error-message {
        margin-top: 2px;
        padding: 5px 5px 5px 10px;
        background-color: indianred;
        width: 100%;
        border-radius: 3px;
        color: white;

    }
</style>
